import React from "react";

const fmt = (v) => (v == null ? "—" : Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 }));

/** Meters whose readings are impossible for the building's size, so they're kept out of totals. */
export function MeterHealthPanel({ meters }) {
  return (
    <>
      <p className="text-xs text-[#6B7280]">
        These readings are far too high for this building&apos;s floor area, so they are excluded
        from the totals above. They usually mean a scaling or counter-reset problem at the meter.
      </p>
      <div className="mt-4 divide-y divide-[#F0F2F1]" data-testid="meter-health-list">
        {meters.map((m) => (
          <div key={m.point_id} className="py-3 flex items-center justify-between gap-4 flex-wrap">
            <div>
              <div className="text-sm font-heading font-semibold text-[#212121]">{m.dis}</div>
              <div className="k-sublabel mt-0.5">
                {m.stream} · {m.unit || "no unit"}
                {m.cumulative_meter ? " · running total" : ""}
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-sm text-[#4D4D4D]">{fmt(m.usage)} {m.unit || ""}</span>
              <span
                className="text-[10px] font-heading font-bold uppercase tracking-wider text-[#B91C1C] bg-[#B91C1C]/10 border border-[#B91C1C]/20 rounded-full px-2 py-0.5"
                data-testid={`meter-flag-${m.point_id}`}
              >
                Check reading
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
